// The group-role <select>, shared by the invite form and the roles table.
//
// Two callers with genuinely different caps, which is why `max` is a parameter
// rather than a constant:
//
//   • the roles table on Manage — Admin, since that page is Admin-gated and
//     changing an existing member's role is an admin power;
//   • the invite form — `maxInvitableRole(myRole)`, so a plain member inviting
//     under `members_open` can only ever add a Member.
//
// Owner (999) is absent from every case by design: it is reserved for the
// creator and moves only by transfer. The server rejects it outright, so this
// is not the enforcement, only the offer.

import { el } from '../dom.js';
import { GRANTABLE_ROLES, GroupRole, groupRoleLabel } from '@msc/shared';

export function roleSelect(
  id: string,
  max: number = GroupRole.ADMIN,
  selected: number = GroupRole.MEMBER,
): HTMLSelectElement {
  const select = el('select', { id, name: 'role' }) as HTMLSelectElement;
  for (const role of GRANTABLE_ROLES) {
    if (role > max) continue;
    const opt = el('option', { value: String(role) }, groupRoleLabel(role)) as HTMLOptionElement;
    if (role === selected) opt.selected = true;
    select.append(opt);
  }
  return select;
}
